import { useFeatureFlags } from '@trimble/feature-flags';
import { Component } from 'solid-js';

import type { FeatureFlagToggleProps } from './FeatureFlagToggle.types';
import { LabeledSwitch } from './LabeledSwitch';

export const FeatureFlagToggle: Component<FeatureFlagToggleProps> = (props) => {
  const { hasFlag } = useFeatureFlags();

  return (
    <LabeledSwitch
      label={props.flag}
      value={hasFlag(props.flag)}
      onToggle={() =>
        props.overrides.setOverride(props.flag, !hasFlag(props.flag))
      }
    />
  );
};
